import { MenuItem } from "@mui/material";
import type { ComponentType, PropsWithChildren } from "react";

export type SelectItemProps = PropsWithChildren<{
  value: string | number;
}>;

// Cast instead of wrapping — MUI requires MenuItem to be a direct child of Menu/Select internally,
// so wrapping it in another component would break that structural assumption.
export const SelectItem = MenuItem as ComponentType<SelectItemProps>;
